"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTemplateAlert = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const lab_1 = require("@material-ui/lab");
const StyledAlert = (0, styled_components_1.default)(lab_1.Alert) `
  margin-left: -30px;
  margin-right: -30px;
  padding-left: 30px;
  padding-right: 30px;
  justify-content: center;
  a {
    text-decoration: underline;
  }
`;
const PageTemplateAlert = props => {
    return react_1.default.createElement(StyledAlert, Object.assign({}, props));
};
exports.PageTemplateAlert = PageTemplateAlert;
exports.default = exports.PageTemplateAlert;
//# sourceMappingURL=PageTemplateAlert.js.map